module.exports = __webpack_public_path__ + "static/media/Dropbase.122deac9.png";